import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-centered-spinner',
  template: `
    <md-progress-spinner
      [color]="'primary'"
      [mode]="'indeterminate'">
    </md-progress-spinner>
  `,
  styles: [`
    :host {
      display:flex;
      position:absolute;
      top:0;
      left:0;
      right:0;
      bottom:0;
      align-items: center;
      justify-content: center;
    }
  `]
})
export class CenteredSpinnerComponent  {}



// WEBPACK FOOTER //
// /var/www/dnata-cerf-front-end/releases/20200326161233/src/app/modules/utilities/components/centered-spinner/centered-spinner.component.ts